export function ErrorCodeResolutionsByErrors(errors: string[]): string[] {
  return ErrorCodeResolutions({
    State: {
      validation: {
        Errors: errors
      }
    }
  });
}

export function ErrorCodeResolutions(item: {
  State?: {
    validation?: {
      Errors?: string[];
    };
  };
}): string[] {
  const output = item.State?.validation?.Errors || [];
  if (!output || output.length == 0) {
    return [];
  }

  // Add additional errors which might could be the cause of this issue
  if (output.includes('SERVICE-UNAVAILABLE')) {
    return ['SERVICE-UNAVAILABLE', 'ITEM-DIMENSIONS-CHANGE'];
  }

  if (output.includes('ADDRESS-RECIPIENT-SAMEEMAIL-SHOP-DELIVERY')) {
    return ['ADDRESS-RECIPIENT-SAMEEMAIL-SHOP-DELIVERY', 'SERVICE-CHANGE'];
  }

  if (output.includes('ADDRESS-RECIPIENT-SAMEEMAIL-LOCKER-DELIVERY')) {
    return ['ADDRESS-RECIPIENT-SAMEEMAIL-LOCKER-DELIVERY', 'SERVICE-CHANGE'];
  }

  if (output.includes('SERVICE-MULTIPARCEL-UNSUPPORTED')) {
    return ['SERVICE-MULTIPARCEL-UNSUPPORTED', 'SERVICE-CHANGE'];
  }

  return [output[0]];
}
